export const APPLICANT_STATUS_MAP = {
  0: '已取消',
  1: '待预审',
  2: '预审未通过',
  3: '待送签',
  4: '使馆审核中',
  5: '出签成功',
  6: '拒签',
  7: '退款中',
  8: '退款成功',
  9: '等待预约',
  10: '待确认',
  11: '等待接收资料',
  12: '等待培训',
  13: '待前往使馆',
  14: '拒签(待提交证明)',
  15: '拒签(等待审核)',
  16: '拒签(审核不通过)',
  17: '预审未通过(待退款)',
  18: '预约成功',
  19: '办理完结',
};
